/**
 * PreviewTable — etapa 3 de "Importar base de clientes" (Item 391-C).
 *
 * Tabela com as primeiras N linhas JÁ MAPEADAS (colunas = os campos de negócio
 * mapeados), para o admin conferir antes de enviar. Linhas/colunas extras do CSV
 * não aparecem — só o que será de fato importado.
 */

import type { MappingDraft } from './MappingStep';

const PREVIEW_LIMIT = 10;

interface PreviewColumn {
  key: keyof MappingDraft;
  label: string;
}

const ALL_COLUMNS: PreviewColumn[] = [
  { key: 'phone', label: 'Telefone' },
  { key: 'holderName', label: 'Nome do titular' },
  { key: 'cpfCnpj', label: 'CPF / CNPJ' },
  { key: 'contractNumber', label: 'Nº do contrato' },
  { key: 'role', label: 'Papel' },
];

export interface PreviewTableProps {
  rows: Record<string, string>[];
  draft: MappingDraft;
}

export function PreviewTable({ rows, draft }: PreviewTableProps): JSX.Element {
  // Só colunas com coluna-de-CSV escolhida no mapeamento.
  const columns = ALL_COLUMNS.filter((c) => draft[c.key] !== '');
  const preview = rows.slice(0, PREVIEW_LIMIT);

  return (
    <section className="cr-step" aria-labelledby="cr-preview-title">
      <h2 id="cr-preview-title" className="cr-step__title">
        <span className="cr-step__num">3</span>
        Conferir prévia
      </h2>

      <div className="cr-preview__wrap">
        <table className="cr-preview__table" data-testid="cr-preview-table">
          <thead>
            <tr>
              {columns.map((c) => (
                <th key={c.key}>{c.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {preview.map((row, idx) => {
              // Chave estável: telefone (se mapeado) + índice — preview é read-only.
              const phoneCol = draft.phone;
              const rowKey = `${phoneCol !== '' ? (row[phoneCol] ?? '') : ''}#${idx}`;
              return (
                <tr key={rowKey}>
                  {columns.map((c) => {
                    const column = draft[c.key];
                    const value = row[column] ?? '';
                    return (
                      <td key={c.key}>
                        {value === '' ? <span className="cr-preview__empty">vazio</span> : value}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {rows.length > PREVIEW_LIMIT && (
        <p className="cr-preview__more">
          Mostrando as primeiras {PREVIEW_LIMIT} de {rows.length} linhas.
        </p>
      )}
    </section>
  );
}
